import { Component } from 'react'
import PropTypes from 'prop-types'

import Icon from './../../Icons'

export class SidebarItem extends Component {
  constructor(props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
  }

  handleClick(e) {
    e.preventDefault()
    const { onSelect, item } = this.props
    onSelect(item)
  }

  renderControl(controls, type) {
    if (controls) {
      switch (type) {
        case 'selection':
          return <Icon icon="cross" className="ctp-sidebar-item__control--selection" />
        case 'switch':
          return <Icon icon="arrow" className="ctp-sidebar-item__control--selection" />
      }
    }
  }
  renderAvatar(avatar) {
    if (avatar) {
      if (avatar.lastIndexOf('http', 0) === 0) {
        return <img src={avatar} className="ctp-sidebar-item__avatar-icon" />
      } else {
        return <Icon icon={avatar} className="ctp-sidebar-item__avatar-icon" />
      }
    }
  }
  render() {
    const { type, isFilter, isSelected, item, controls } = this.props
    const isDropdown = type === 'dropdown'
    const className = `ctp-sidebar-item ${
      isDropdown
        ? isSelected
          ? 'ctp-sidebar-item-dropdown ctp-sidebar-item-dropdown--selected'
          : 'ctp-sidebar-item-dropdown'
        : isSelected
          ? 'ctp-sidebar-item-selection ctp-sidebar-item-selection--selected'
          : 'ctp-sidebar-item-selection'
    }`

    const avatarClass = `ctp-sidebar-item__avatar ${
      isFilter ? 'ctp-sidebar-item__avatar--filter' : ''
    }`
    const avatarStyle = {
      backgroundColor: isFilter ? 'lightgray' : item.color ? item.color : 'lightgray',
    }
    return (
      <div
        className={className}
        onClick={type === 'selection' ? (e) => e.preventDefault() : this.handleClick}
      >
        {item.avatar && (
          <div className={avatarClass} style={avatarStyle}>
            {this.renderAvatar(item.avatar)}
          </div>
        )}
        <div className="ctp-sidebar-item__text">{item.text}</div>
        <div className="ctp-sidebar-item__control" onClick={this.handleClick}>
          {this.renderControl(controls, type)}
        </div>
      </div>
    )
  }
}

SidebarItem.propTypes = {
  type: PropTypes.string,
  item: PropTypes.object,
  onSelect: PropTypes.func,
  controls: PropTypes.bool,
  isFilter: PropTypes.bool,
  isSelected: PropTypes.bool,
}
export default SidebarItem
